import React from 'react'

import ExpirationErrorImg from 'images/expiration_error.svg'
import DealErrorTemplate from 'layouts/DealErrorTemplate'

import { track } from 'utils/trackingUtils'

const EXPIRED_HEADER = 'Looks like your invoice is still pending'
const EXPIRED_DESCRIPTION = 'You’ll be able to create an account once your invoice has been approved.'

const DealPendingLayout = () => (
  <DealErrorTemplate
    splashImage={ExpirationErrorImg}
    header={EXPIRED_HEADER}
    description={EXPIRED_DESCRIPTION}
    onMounted={() => track('Deal Flow - Deal Pending Page Hit')}/>
)

export default DealPendingLayout